




























import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import JdhLogicalCheckbox from "@/design-system/forms/fields/JdhLogicalCheckbox.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdhErrorMessage from "@/design-system/forms/fields/JdhErrorMessage.vue"
import JdhValidationProvider from "@/design-system/forms/fields/JdhValidationProvider.vue"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({
    components: {JdhValidationProvider, JdhErrorMessage, JdhHeightTransition, JdhLogicalCheckbox}
})
export default class JdsCheckbox extends Mixins(UniqueIdMixin) {
    @Prop() value!: boolean
    @Prop({type: Boolean, default: false}) required!: boolean

    noop(){}

    get rules () {
        return {
            ... (this.required && {required: { allowFalse: false }})
        }
    }
}
